module.exports = __webpack_public_path__ + "fonts/ionicons.98a02ea.woff2";